import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热门话题
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            追剧圈最火的话题都在这里
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => {
            const sizes = ['lg', 'md', 'md', 'sm', 'md', 'sm', 'lg', 'sm', 'md', 'sm', 'md'];
            const size = sizes[i % sizes.length];
            const paddingClass = size === 'lg' ? 'px-6 py-3' : size === 'md' ? 'px-5 py-2.5' : 'px-4 py-2';
            const textClass = size === 'lg' ? 'text-base' : size === 'md' ? 'text-sm' : 'text-xs';

            return (
              <a
                key={topic.name}
                href="#topics"
                className={`group flex items-center gap-2 ${paddingClass} rounded-full bg-background-50 border border-background-200/60 hover:border-primary-300/40 hover:bg-primary-50 transition-all duration-300 no-underline cursor-pointer`}
              >
                <span className={`${textClass} font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap`}>
                  {topic.name}
                </span>
                <span className={`${textClass} text-foreground-400 whitespace-nowrap`}>
                  {topic.count.toLocaleString()}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}